import { Checkbox, FormControl, FormControlLabel, MenuItem, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import * as yup from 'yup';
import { PatientCompleteWizardType } from '../ui/WizardStep.tsx';

const tobaccoFrequencyOptions = ['Tous les jours', 'Toutes les semaines', 'Tous les mois', 'Rarement'];

const substancesTypeOptions = ['Cannabis', 'Cocaïne', 'Psychédéliques', 'Champignons', 'LSD', 'MDMA', 'Héroïne', 'Autre'];

const substancesFrequencyOptions = ['Tous les jours', 'Toutes les semaines', 'Tous les mois', 'Rarement'];

const PatientCompleteWizardStep2: PatientCompleteWizardType = ({ formik }) => {
  //const formik: FormikContextType<PatientInclusionInfo> = useFormikContext<PatientInclusionInfo>();
  return (
    <>
      <Grid container spacing={3}>
        <Grid size={2} />
        <Grid size={4}>
          <FormControlLabel control={<Checkbox checked={formik.values.alcohol} name="alcohol" onChange={formik.handleChange} />} label="Consommation alcool" />
        </Grid>
        <Grid size={6}>
          {formik.values.alcohol && (
            <FormControl fullWidth>
              <TextField
                error={formik.touched.alcoholUnits && Boolean(formik.errors.alcoholUnits)}
                fullWidth
                helperText={formik.touched.alcoholUnits && formik.errors.alcoholUnits}
                label="Unités d'alcool par semaine"
                name="alcoholUnits"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="number"
                value={formik.values.alcoholUnits}
              />
            </FormControl>
          )}
        </Grid>
        <Grid size={2} />
        <Grid size={4}>
          <FormControlLabel
            control={<Checkbox checked={formik.values.substances} name="substances" onChange={formik.handleChange} />}
            label="Consommation de substances"
          />
        </Grid>
        <Grid size={6}>
          {formik.values.substances && (
            <Grid container spacing={1}>
              <Grid size={6}>
                <FormControl fullWidth>
                  <TextField
                    error={formik.touched.substancesType && Boolean(formik.errors.substancesType)}
                    helperText={formik.touched.substancesType && formik.errors.substancesType}
                    label="Substances"
                    name="substancesType"
                    onBlur={formik.handleBlur}
                    onChange={(event) => {
                      const { value } = event.target;
                      void formik.setFieldValue('substancesType', typeof value === 'string' ? value.split(',') : value);
                    }}
                    select
                    slotProps={{ select: { multiple: true } }}
                    value={formik.values.substancesType}
                  >
                    {substancesTypeOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth>
                  <TextField
                    error={formik.touched.substancesFrequency && Boolean(formik.errors.substancesFrequency)}
                    helperText={formik.touched.substancesFrequency && formik.errors.substancesFrequency}
                    label="À quelle fréquence ?"
                    name="substancesFrequency"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    select
                    value={formik.values.substancesFrequency}
                  >
                    {substancesFrequencyOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid size={2} />
        <Grid size={4}>
          <FormControlLabel
            control={<Checkbox checked={formik.values.tobacco} name="tobacco" onChange={formik.handleChange} />}
            label="Consommation de tabac"
          />
        </Grid>
        {formik.values.tobacco ? (
          <Grid size={6}>
            <FormControl fullWidth>
              <TextField
                error={formik.touched.tobaccoFrequency && Boolean(formik.errors.tobaccoFrequency)}
                helperText={formik.touched.tobaccoFrequency && formik.errors.tobaccoFrequency}
                label="À quelle fréquence ?"
                name="tobaccoFrequency"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                select
                value={formik.values.tobaccoFrequency}
              >
                {tobaccoFrequencyOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        ) : (
          <Grid size={6}></Grid>
        )}

        <Grid size={2} />
        <Grid size={10}>
          <FormControlLabel
            control={<Checkbox checked={formik.values.pregnancy} name="pregnancy" onChange={formik.handleChange} />}
            label="Grossesse en cours"
          />
        </Grid>
        <Grid size={2} />
        <Grid size={10}>
          <FormControlLabel
            control={<Checkbox checked={formik.values.breastfeeding} name="breastfeeding" onChange={formik.handleChange} />}
            label="Allaitement en cours"
          />
        </Grid>
      </Grid>
    </>
  );
};

PatientCompleteWizardStep2.label = 'Conditions particulières';

PatientCompleteWizardStep2.initialValues = {
  alcohol: false,
  alcoholUnits: '',
  substances: false,
  substancesType: [],
  substancesFrequency: '',
  tobacco: false,
  tobaccoFrequency: '',
  breastfeeding: false,
  pregnancy: false,
};

PatientCompleteWizardStep2.validationSchema = yup.object().shape({
  alcohol: yup.boolean(),
  alcoholUnits: yup.string().when('alcohol', {
    is: true,
    then: (schema) =>
      schema
        .required("Combien d'unités d'alcool par semaine ?")
        .test('is-greater-than-zero', "Le nombre d'unités d'alcool doit être supérieur à 0", (value) => parseFloat(value) > 0),
  }),
  substances: yup.boolean(),
  substancesType: yup
    .array()
    .of(yup.string())
    .when('substances', {
      is: true,
      then: (schema) => schema.min(1, 'Sélectionner au moins une substance').required('Sélectionner les substances'),
    }),
  substancesFrequency: yup.string().when('substances', {
    is: true,
    then: (schema) => schema.oneOf(substancesFrequencyOptions, 'Sélectionner une option valide').required('À quelle fréquence ?'),
  }),
  tobacco: yup.boolean(),
  tobaccoFrequency: yup.string().when('tobacco', {
    is: true,
    then: (schema) => schema.oneOf(tobaccoFrequencyOptions, 'Sélectionner une option valide').required('À quelle fréquence ?'),
  }),
  breastfeeding: yup.boolean(),
  pregnancy: yup.boolean(),
});
export default PatientCompleteWizardStep2;
